import React from 'react';
import css from './Label.module.css';
import { FieldState } from '../../models';
import clsx from 'clsx';
import { H3 } from '../../../text';

interface LabelProps {
  state: FieldState;
  required?: boolean;
  text: string;
}

const Label: React.FC<LabelProps> = (props: LabelProps) => {
  const { required = false } = props;
  const stateStyle = (): string | undefined => {
    switch (props.state) {
      case FieldState.Disabled:
        return css.disabled;
      case FieldState.Error:
        return css.error;
      case FieldState.Active:
        return css.active;
      case FieldState.Inactive:
      default:
        return css.inactive;
    }
  };

  return (
    <div>
      {required ? (
        <H3 className={clsx(css.required, stateStyle())} text="* " />
      ) : null}
      <H3 className={clsx(css.labelText, stateStyle())} text={props.text} />
    </div>
  );
};

export default Label;
